export default "__VITE_ASSET__DOoQRjbX__"